import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Table, Form, Image, Button, Divider, } from 'semantic-ui-react';
import Select from 'react-select';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
//import RenderItems from './RenderItems';
import axios from 'axios'
import { serverIp, firebaseAuth, toCurrency,firebaseStorage, logComponentLoad } from '../../../../config/constants.js'
//import { getShirtTypeDownDown } from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'
import * as UiConsts from '../../../../config/UiConstants';
import GetRecentUnPaidStockPaymentsCell from './GetRecentUnPaidStockPaymentsCell';
import FileUploader from 'react-firebase-file-uploader';

class GetRecentUnPaidStockPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            days_total: 0,
            numItems: 0,
            unpaidList: [],
            payItemArray: [],
            paymentTotal: 0,

            dailyExpenseOptions: [],
            dailyExpense: '',
            newDailyExpense: '',
            amount: '',
            itemArray: [],
            runningTotal: '',
            shirtTypeOptions: [],
            loading: false,
        }
    }


    componentDidMount() {
        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        //getPrintValues("dailyExpenses", this.setDailyExpenseOptions);

        //getShirtTypesToDisplay(this.setShirtTypeDropDown, "daily_expenses");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        //logComponentLoad(returnObject, "PaymentsPage", returnObject.algoliaUser.key);

        logComponentLoad(returnObject, "getUnPaidStockItemsList");

        // if (returnObject.algoliaUser.dailyExpenses) { 
        if (returnObject.algoliaUser.perms.includes("getRecentUnPaidStockPayments")) {
            console.log("user authed: returnObject.algoliaUser.getRecentUnPaidStockPayments");

            this.getUnPaidStockItemsList();

        } else {
            console.log("FAILED AUTH: returnObject.algoliaUser.dailyExpenses");
            //

        }

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            dailyExpenseOptions: shirtTypes
        })

    }

    setDailyExpenseOptions = (objects) => {
        console.log("obx1 +++++++:setDailyExpenseOptions");
        // console.log("obx12 hits:"+JSON.stringify(objects, null, 3));
        this.setState({
            dailyExpenseOptions: objects
        })

    }

    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('cv32 You\'ve sss:', value);
        console.log('cv32 You\'ve selected:', value.value + " " + value.category);


        this.setState({
            dailyExpense: value.value,
            newDailyExpense: value.label,
        });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    addItem = (sentItem) => {
        console.log("++++++++:addItem");
        console.log("sentItem:" + sentItem);

        //if (this.state.unpaidList.some(e => e.idreceiptItemList === sentItem.idreceiptItemList)) {
        if (this.state.payItemArray.some(e => e.idreceiptItemList === sentItem.idreceiptItemList)) {
            console.log("payItemArray already contains " + sentItem.idreceiptItemList);

            let tempArray = this.state.payItemArray;
            tempArray.splice(tempArray.findIndex(v => v.idreceiptItemList === sentItem.idreceiptItemList), 1);

            console.log("tempArray size:" + tempArray.length);

            this.setState({
                payItemArray: tempArray
            }, this.getTotal())
        } else {
            console.log("unpaidList DOES NOT contain " + sentItem.idreceiptItemList);

            let tempArray = this.state.payItemArray;
            sentItem.dateEntered = null;
            sentItem.stockPaidDate = null;
            tempArray.push(sentItem)

            console.log("tempArray size:" + tempArray.length);
            this.setState({
                payItemArray: tempArray
            }, this.getTotal())
        }

        console.log("payItemArray size:" + this.state.payItemArray.length);

        // let item = {};
        // //item.itemCode = this.state.dailyExpense;
        // item.itemCode = this.state.newDailyExpense;
        // item.amount = this.state.amount;
        // item.notes = this.state.notes;

        // console.log("itx1:" + JSON.stringify(item, null, 3));

        // let tempArray = this.state.itemArray;
        // tempArray.push(item);

        // console.log("itx12 after adding item:" + JSON.stringify(item, null, 3));

        // this.setState({
        //     itemArray: tempArray
        // }, this.resetAfterAdding());
    }



    removeItem = (valueToRemove) => {
        console.log("itx21 ++++++ removeItem");
        let tempList = [];
        tempList = this.state.itemArray.filter(item => item !== valueToRemove)

        this.setState({
            itemArray: tempList
        })

        console.log("itx21 wishListJson size:" + tempList.length);
        console.log("itx21 wishListJson size:" + JSON.stringify(tempList, null, 3));
        //this.calculateTotal('deduct');
    }

    resetAfterAdding = () => {
        console.log("++++++++:resetAfterAdding");
        console.log("new state item array:" + JSON.stringify(this.state.itemArray))
        this.setState({
            dailyExpense: '',
            newDailyExpense: '',
            amount: '',
            notes: ''
            //itemArray:[]
        })
    }

    getUnPaidStockItemsList = () => {
        console.log("++++++++:sendList");
        console.log("new state item array:" + JSON.stringify(this.state.itemArray));
        console.log("date:" + this.state.dateNum);

        this.setState({ loading: true });

        axios.post(serverIp + 'stockPayment/getRecentUnPaidStockPayments', {
            apiKey: "ad#4fsdUUddf",
            numRecords: 100,
            enteredBy: this.state.user.email,
            action: "no_requisition"
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false });

                    // alert("expenses sent.");
                    this.setState({
                        days_total: response.data.dailyExpense_cont.days_total,
                        numItems: response.data.dailyExpense_cont.numItems,
                        unpaidList: response.data.dailyExpense_cont.daList
                    })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });

    }

    sendPayment = () => {
        console.log("++++++++:sendPayment");
        console.log("new state payItemArray:" + JSON.stringify(this.state.payItemArray));


        this.setState({ loading: true });

        axios.post(serverIp + 'stockPayment/manualStockPayment', {
            apiKey: "ad#4fsdUUddf",
            payItemArray: this.state.payItemArray,
            enteredBy: this.state.user.email,
            imageUrl: this.state.docUrl
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ 
                        loading: false,
                        payItemArray: [],
                        docUrl:null,
                        paymentTotal:0
                    });

                    this.getUnPaidStockItemsList();

                    alert(response.data.message);

                    // alert("expenses sent.");
                    // this.setState({
                    //     days_total: response.data.dailyExpense_cont.days_total,
                    //     numItems: response.data.dailyExpense_cont.numItems,
                    //     unpaidList: response.data.dailyExpense_cont.daList
                    // })

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });

    }

    getTotal = () => {
        console.log("++++ gtx getTotal");

        let total = 0;
        this.state.payItemArray.forEach(element => {
            //  console.log("gtx10 get element cost:" + (element.qty * element.cost))
            total += (element.total)
            console.log("gtx12 new total:" + total)
        });

        this.setState({
            paymentTotal: total
        })
    }

    /**
* HANDLE THE FILE UPLOADING..
*/
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }

    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }

    render() {

        const imagePreview = this.state.docUrl
        ? <Image src={this.state.docUrl} size='medium' centered bordered shape='rounded' />
        : ''

        const fileUploadUI = this.state.payItemArray.length > 0 
        ? <div>
            <h4>UPLOAD RECEIPT: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
        </div>
        : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        // const payTodaysItems = this.state.user
        //     && this.state.user.email && this.state.algoliaUser != null
        //     && (this.state.algoliaUser.dailyExpenses && this.state.algoliaUser.perms.includes("payTodaysItems"))
        //     ? <PayTodaysItems user={this.state.user} />
        //     : ''

        const tableRow = this.state.unpaidList.length > 0
            ? this.state.unpaidList.map((trans) =>
                <Table.Row>
                    <Table.Cell> {trans.dateEntered} </Table.Cell>
                    <Table.Cell>{trans.shirtType}</Table.Cell>
                    <Table.Cell>{trans.qty}</Table.Cell>
                    <Table.Cell>{toCurrency(trans.shirtTypeBuyCost)}</Table.Cell>
                    <Table.Cell>{toCurrency(trans.total)}</Table.Cell>
                    <Table.Cell>{trans.idreceiptItemList}</Table.Cell>
                    <Table.Cell>
                        <GetRecentUnPaidStockPaymentsCell
                            unpaidItem={trans}
                            addItem={this.addItem}
                            title='ADD ITEM' />
                    </Table.Cell>
                </Table.Row>)
            : ''

        const tableBody = <div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Date Entered</Table.HeaderCell>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>qty</Table.HeaderCell>
                        <Table.HeaderCell>Cost</Table.HeaderCell>
                        <Table.HeaderCell>Total</Table.HeaderCell>
                        <Table.HeaderCell>id</Table.HeaderCell>
                        <Table.HeaderCell>Pay</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>
            </Table>
        </div>

        const unpaidTableRow = this.state.payItemArray.length > 0
            ? this.state.payItemArray.map((trans) =>
                <Table.Row>
                    {/* <Table.Cell> {trans.dateEntered} </Table.Cell> */}
                    <Table.Cell>{trans.shirtType}</Table.Cell>
                    <Table.Cell>{trans.qty}</Table.Cell>
                    <Table.Cell>{toCurrency(trans.shirtTypeBuyCost)}</Table.Cell>
                    <Table.Cell>{toCurrency(trans.total)}</Table.Cell>
                    <Table.Cell>{trans.idreceiptItemList}</Table.Cell>
                    {/* <Table.Cell>
                        <GetRecentUnPaidStockPaymentsCell
                            unpaidItem={trans}
                            addItem={this.addItem} 
                            title='REMOVE'/>
                    </Table.Cell> */}
                </Table.Row>)
            : ''

        const payButton = this.state.payItemArray.length > 0
            ? <Button color='red' fluid onClick={this.sendPayment}> PAY </Button>
            : ''

        const unpaidTableBody = <div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        {/* <Table.HeaderCell>Date Entered</Table.HeaderCell> */}
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>qty</Table.HeaderCell>
                        <Table.HeaderCell>Cost</Table.HeaderCell>
                        <Table.HeaderCell>Total</Table.HeaderCell>
                        <Table.HeaderCell>recieptNum</Table.HeaderCell>
                        {/* <Table.HeaderCell>Pay</Table.HeaderCell> */}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {unpaidTableRow}
                </Table.Body>
            </Table>
            {fileUploadUI}
            {imagePreview}
            {payButton}

        </div>

        const wholeUI = this.state.user
            && this.state.user.email && this.state.algoliaUser != null
            && this.state.algoliaUser.perms.includes("getRecentUnPaidStockPayments")
            ? <div>

                <h3>
                    Total:{toCurrency(this.state.days_total)}
                </h3>
                <h3>
                    Num Items:{this.state.numItems}
                </h3>

                <Divider horizontal>{'PAY LIST, TOTAL:'}{toCurrency(this.state.paymentTotal)}</Divider>
                {unpaidTableBody}

                <Divider horizontal>{'UNPAID LIST'}</Divider>
                {tableBody}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h1>UnPaid Stock Items</h1>
            {wholeUI}

        </div>);
    }
}

export default GetRecentUnPaidStockPayments;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/GetRecentUnPaidStockPayments.js